import ConfiguracoesDetro from '../config-tipos-relatorio/detro'
import ConfiguracoesPoliciaCivil from '../config-tipos-relatorio/policia-civil'
import ConfiguracoesLeilao from '../config-tipos-relatorio/leilao'
import ConfiguracoesDetranES from '../config-tipos-relatorio/detranES'
import {
  GRV_DETRO,
  GRV_ESPIRITO_SANTO,
  GRV_PREFEITURA,
  GRV_POLICIA_CIVIL,
  GRV_CAMPOS_DOS_GOYTACAZES
} from '../../../../domain/grv/helpers/tipos-grv'

export const CONTRATO_DETRO = GRV_DETRO
export const CONTRATO_POLICIA_CIVIL = GRV_POLICIA_CIVIL
export const CONTRATO_LEILAO = 2
export const CONTRATO_DETRAN_ES = GRV_ESPIRITO_SANTO
export const CONTRATO_PREFEITURA = GRV_PREFEITURA
export const CONTRATO_CAMPOS_DOS_GOYTACAZES = GRV_CAMPOS_DOS_GOYTACAZES

export const configuracoesContratos = {
  [CONTRATO_DETRO]: {
    label: 'DETRO/RJ',
    configuracoes: ConfiguracoesDetro
  },
  [CONTRATO_POLICIA_CIVIL]: {
    label: 'Polícia Civil',
    configuracoes: ConfiguracoesPoliciaCivil
  },
  [CONTRATO_LEILAO]: {
    label: 'Leilão',
    configuracoes: ConfiguracoesLeilao
  },
  [CONTRATO_DETRAN_ES]: {
    label: 'DETRAN/ES',
    configuracoes: ConfiguracoesDetranES
  },
  [CONTRATO_PREFEITURA]: {
    label: 'Prefeitura Barra do Piraí',
    configuracoes: ConfiguracoesDetro
  },
  [CONTRATO_CAMPOS_DOS_GOYTACAZES]: {
    label: 'Campos dos Goytacazes',
    configuracoes: ConfiguracoesDetro
  }
}



// WEBPACK FOOTER //
// ./src/app/website/relatorios-gerenciais/configuracoes-contratos/configuracoes-contratos.js